import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { ThemeService, type Theme } from '@services/theme/theme.service';

interface ThemeOption {
  readonly value: Theme;
  readonly icon: string;
  readonly label: string;
}

@Component({
  selector: 'app-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeToggleComponent {
  readonly themeService = inject(ThemeService);

  readonly currentOption = computed(() => {
    const preference = this.themeService.preference();
    const options: Record<Theme, ThemeOption> = {
      light: { value: 'light', icon: 'sun', label: 'Light' },
      dark: { value: 'dark', icon: 'moon', label: 'Dark' },
      system: { value: 'system', icon: 'desktop', label: 'System' },
    };
    return options[preference];
  });

  readonly nextTheme = computed<Theme>(() => {
    const preference = this.themeService.preference();
    return preference === 'system' ? 'light' : preference === 'light' ? 'dark' : 'system';
  });

  readonly accessibleLabel = computed(() => {
    const next = this.nextTheme();
    return `${this.currentOption().label} theme selected. Switch to ${next} theme.`;
  });

  cycleTheme(): void {
    this.themeService.setTheme(this.nextTheme());
  }
}
